import type {FC} from 'react';
import {components, type SingleValueProps} from 'react-select';

import styled from 'styled-components';

import type {SelectV2} from '../Select.v2';

import {getColor, ms, type ThemeAndAnyColor} from '../../../../styles';
import {useSelectV2OptionIcon} from './hooks/useSelectV2OptionIcon';
import {ThemeForwardingWrapper} from './SelectThemeForwarding.v2';

const ForwardedWrapper = ({forwardTheme, ...props}) => {
  return (
    <ThemeForwardingWrapper
      Component={components.SingleValue}
      forwardTheme={forwardTheme}
      {...props}
    />
  );
};

const Container = styled(ForwardedWrapper)<{
  textColor: ThemeAndAnyColor;
}>`
  && {
    color: ${p => getColor(p.textColor)(p)};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${ms(4)};
  }
`;

export const SelectSingleValueV2: FC<SelectSingleValueV2.Props> = ({
  children,
  theme,
  ...rest
}) => {
  const {renderIcon, textColor} = useSelectV2OptionIcon({
    data: rest.data,
    textColor: 'text.black',
  });

  return (
    <Container {...rest} forwardTheme={theme} textColor={textColor}>
      {renderIcon()}
      {children}
    </Container>
  );
};

export namespace SelectSingleValueV2 {
  export type Props = SingleValueProps &
    Pick<SelectV2.Props, 'scheme'> &
    Required<Pick<SelectV2.Props, 'size'>>;
}
